<template>
  <section class="mobile-platform-module-grid" data-qa="mobile-platform-module-grid">
    <header class="mobile-platform-module-grid__header">
      <VcImage
        v-if="logo"
        class="mobile-platform-module-grid__logo"
        :image="logo"
        data-qa="mobile-platform-module-grid-logo"
      />
      <h1 class="mobile-platform-module-grid__title" data-qa="mobile-platform-module-grid-title">
        <span class="mobile-platform-module-grid__title-primary">{{ titlePrimaryText }}</span>
        <span v-if="titleSecondaryText"> {{ titleSecondaryText }}</span>
      </h1>
    </header>

    <VcLayout v-if="isLoading" class="mobile-platform-module-grid__loader" justify-center>
      <VcLoader :size="32" data-qa="mobile-platform-module-grid-loader" />
    </VcLayout>

    <div v-else class="mobile-platform-module-grid__items">
      <button
        v-for="item in items"
        :key="item.uid"
        type="button"
        class="mobile-platform-module-grid__item"
        data-qa="mobile-platform-module-grid-item"
        @click="$emit('item-click', item)"
      >
        <span class="mobile-platform-module-grid__item-content">
          <span
            class="mobile-platform-module-grid__icon-container"
            :data-icon="getItemIcon(item)"
            data-qa="mobile-platform-module-grid-item-icon"
          >
            <VcIcon aria-hidden="true" size="20">
              {{ getItemIcon(item) }}
            </VcIcon>
          </span>
          <span class="mobile-platform-module-grid__item-label">
            {{ getItemTitle(item) }}
          </span>
        </span>
      </button>
    </div>
  </section>
</template>

<script>
const DEFAULT_MODULE_ICON = 'icon-App_Market_POV';

export default {
  name: 'MobilePlatformModuleGrid',
  props: {
    title: {
      type: String,
      required: true,
    },
    logo: {
      type: [String, Object],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    getItemTitle: {
      type: Function,
      required: true,
    },
  },
  computed: {
    titlePrimaryText() {
      return this.title.replace(/\sHome$/i, '');
    },
    titleSecondaryText() {
      return /\sHome$/i.test(this.title) ? 'Home' : '';
    },
  },
  methods: {
    getItemIcon(item) {
      return item.icon || DEFAULT_MODULE_ICON;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-platform-module-grid {
  position: fixed;
  top: var(--vc-top-bar-height);
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 11;
  overflow-y: auto;
  padding: var(--size-value10) var(--size-value7) var(--size-value4);
  background-color: var(--neutral-lighten-3);
  text-align: start;

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--size-value2);
    margin-bottom: var(--size-value8);
    text-align: center;
  }

  &__logo {
    width: var(--size-value7);
    height: var(--size-value8);
    flex: 0 0 var(--size-value7);

    &::v-deep {
      .VcImage {
        justify-content: center;
      }

      .image {
        max-width: 100%;
        max-height: var(--size-value7);
        overflow: hidden;
      }
    }
  }

  &__title {
    margin: 0;
    color: var(--gray-darken-5);
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-medium);
    line-height: var(--size-value8);
    white-space: nowrap;
  }

  &__title-primary {
    font-weight: 700;
  }

  &__loader {
    min-height: var(--size-value16);
  }

  &__items {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--size-value5);
  }

  &__item {
    appearance: none;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 168px;
    padding: 18px 16px;
    border: 0;
    border-radius: 18px;
    background-color: white;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    text-align: start;
  }

  &__item-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--size-value5);
    width: 100%;
    color: var(--gray-darken-5);
  }

  &__icon-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--size-value9);
    height: var(--size-value9);
    flex: 0 0 var(--size-value9);
    border-radius: 50%;
    background-color: rgba(237, 247, 250, 0.85);
  }

  &__item-label {
    display: block;
    white-space: normal;
    color: var(--gray-darken-5);
    font-size: 17px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: 0;
  }
}
</style>
